import { Injectable } from '@angular/core';
import featureRoles from '../../constants/feature-roles';
import { ApplicationFeatures, UserRoles } from '../../enums/enums';
import { AuthService } from '../../../auth/auth.service/auth.service';
import {BusinessRoleDto, BusinessRolesClient} from '../../../api/auth-api.generated';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserRoleService {

  private roles: { [id: string]: UserRoles[] };

  constructor(private authService: AuthService,
              private businessRolesClient: BusinessRolesClient) {
    this.parseRoleClaims();

    this.authService.authState$.pipe().subscribe(() => {
      this.parseRoleClaims();
    });
  }

  parseRoleClaims() {
    const tokenPayload = this.authService.getTokenPayload();
    this.parseRoles(tokenPayload);
  }

  parseRoles(tokenPayload: any): void {
    const profileRoles: { [id: string]: UserRoles[] } = {};

    const parseRoleFunc = (role: any) => {
      const values = role.split(':');
      if (values.length === 2) {
        const profileId = values[0] as UserRoles;
        if (!profileRoles[profileId]) { profileRoles[profileId] = []; }
        profileRoles[profileId].push(values[1]);
      }
    };

    if (tokenPayload?.role) {
      if (Array.isArray(tokenPayload.role)) { tokenPayload.role.map(x => parseRoleFunc(x)); }
      else { parseRoleFunc(tokenPayload.role); }
    }

    this.roles = profileRoles;
  }

  public controllableProfile(profileId: string): boolean {
    if (!profileId || !this.roles || !this.roles[profileId]) { return false; }

    const roles = this.roles[profileId];
    return roles.includes(UserRoles.owner) || roles.includes(UserRoles.manager);
  }

  public isOnlyViewer(profileId: string): boolean {
    if (!this.roles || !this.roles[profileId]) { return true; }

    const roles = this.roles[profileId];
    if (roles.includes(UserRoles.owner) || roles.includes(UserRoles.manager) || roles.includes(UserRoles.cashier) ||
      roles.includes(UserRoles.developer)) { return false; }

    // else Viewer
    return true;
  }

  public isOnlyOwner(profileId: string): boolean {
    if (!this.roles || !this.roles[profileId]) { return true; }

    const roles = this.roles[profileId];
    if (roles.includes(UserRoles.viewer) || roles.includes(UserRoles.manager) || roles.includes(UserRoles.cashier) ||
      roles.includes(UserRoles.developer)) { return false; }

    // else Owner only
    return true;
  }

  public isDeveloper(profileId: string): boolean {
    if (!this.roles || !this.roles[profileId]) { return false; }

    const roles = this.roles[profileId];
    return roles.includes(UserRoles.developer);

  }

  public profileRoles(profileId: string): UserRoles[] {
    if (!this.roles || !this.roles[profileId]) { return null; }

    return this.roles[profileId];
  }

  public getAcceptedNonViewerRoles(profileId: string): Observable<BusinessRoleDto[]> {
    return this.businessRolesClient.getAcceptedNonViewerRoles(profileId);
  }
}

export const getFeatureRoles = (applicationFeatures: ApplicationFeatures): UserRoles[] =>
  featureRoles.find(x => x.feature === applicationFeatures).roles;
